import { render, staticRenderFns } from "./RollbackInstanceBackup.vue?vue&type=template&id=1edd6a5d&"
import script from "./RollbackInstanceBackup.vue?vue&type=script&lang=js&"
export * from "./RollbackInstanceBackup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports